"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _Bullets = _interopRequireDefault(require("../../../Bullets/Bullets"));
var _react = require("react");
var _useSlider = _interopRequireDefault(require("../../hooks/useSlider"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var SliderBullets = /*#__PURE__*/(0, _react.forwardRef)(function (_a, ref) {
  var className = _a.className;
  var _b = (0, _useSlider.default)(),
    _c = _b.index,
    index = _c === void 0 ? 0 : _c,
    slidesLength = _b.slidesLength,
    direction = _b.direction,
    _d = _b.dynamicBullets,
    dynamicBullets = _d === void 0 ? false : _d,
    goToIndex = _b.goToIndex;
  return (0, _jsxRuntime.jsx)(_Bullets.default, {
    index: index,
    className: className,
    direction: direction,
    count: slidesLength,
    dynamicBullets: dynamicBullets,
    activeIndex: index,
    onBulletClick: goToIndex
  });
});
var _default = SliderBullets;
exports.default = _default;